import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx"; // For Excel export
import { Dropdown, DropdownButton } from "react-bootstrap";
import Logo from "../logo.png";
import "../App.css";

const ReceivingList = () => {
  const navigate = useNavigate();
  const [receiving, setReceiving] = useState([]);
  const [filteredReceiving, setFilteredReceiving] = useState([]);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterItemName, setFilterItemName] = useState("");
  const [error, setError] = useState("");
  const [selectedClient, setSelectedClient] = useState("All"); // Default to "All"
  const [token, setToken] = useState(process.env.REACT_APP_CLIENT_DIHTOKEN);
  const [filterCenter, setFilterCenter] = useState("all");
  const [filterSearch, setFilterSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("all"); // Status filter state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" }); // Sorting state
const [showFields, setShowFields] = useState({
  insertDate: false,
  lastUpdatedDate: false,
  purchaseOrderNumber: false, // Add this
});
  const [showFieldDropdown, setShowFieldDropdown] = useState(false);

  const clients = [
    { name: "All", token: "all" }, // Add this line
   { name: "Bettr Performance", token: process.env.REACT_APP_CLIENT_BettrPerformance },
    { name: "Bodysocks", token: process.env.REACT_APP_CLIENT_BODYSOCKSTOKEN },
    { name: "Ceejay", token: process.env.REACT_APP_CLIENT_Ceejay },
    { name: "Charcoal", token: process.env.REACT_APP_CLIENT_Charcoal },
    { name: "DIH", token: process.env.REACT_APP_CLIENT_DIHTOKEN },
    { name: "DRMTLGY", token: process.env.REACT_APP_CLIENT_DRMTLGYTOKEN },
    { name: "EcoSoul", token: process.env.REACT_APP_CLIENT_EcoSoul },
    { name: "First Organic Healthcare", token: process.env.REACT_APP_CLIENT_FIRSTORGANICHEALTHCARE_TOKEN },
    { name: "Grace and Company", token: process.env.REACT_APP_CLIENT_GRACEANDCOMPANYTOKEN },
    { name: "IDAM", token: process.env.REACT_APP_CLIENT_IDAMTOKEN },
    { name: "khanal Foods", token: process.env.REACT_APP_CLIENT_KHANALFOODSTOKEN },
    { name: "Loftex", token: process.env.REACT_APP_CLIENT_LOFTEXTOKEN },
    { name: "Naturally Royal", token: process.env.REACT_APP_CLIENT_NATURALLYROYALTOKEN },
    { name: "OJOOK Care", token: process.env.REACT_APP_CLIENT_OJOOKCARETOKEN },
   { name: "Resaltz", token: process.env.REACT_APP_CLIENT_RESALZTOKEN },
            { name: "RISHABH99 LLC", token: process.env.REACT_APP_CLIENT_RISHABH99LLCTOKEN },

    { name: "Smartivity", token: process.env.REACT_APP_CLIENT_SMARTIVITYTOKEN },
    { name: "Splendid Udyog", token: process.env.REACT_APP_CLIENT_SPLENDIDUDYOGTOKEN },

    { name: "Tandem Design Co", token: process.env.REACT_APP_CLIENT_TANDEMDESIGNCOTOKEN },
    { name: "Treespoon", token: process.env.REACT_APP_CLIENT_TREESPOONTOKEN },
    { name: "Vedix Ayurveda", token: process.env.REACT_APP_CLIENT_VEDIXAYURVEDATOKEN },
    { name: "Warpfy", token: process.env.REACT_APP_CLIENT_WARPFYTOKEN }
    ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
    
        let allReceiving = [];
        let allInventory = [];
    
        if (selectedClient === "All") {
          // Fetch data for all clients
          for (const client of clients) {
            if (client.name === "All") continue; // Skip the "All" option
    
            // Fetch Receiving Data for the current client (with pagination)
            let receivingPage = 1;
            let hasMoreReceiving = true;
            while (hasMoreReceiving) {
              const receivingResponse = await axios.get(
                "https://api.shipbob.com/2.0/receiving",
                {
                  params: {
                    Page: receivingPage,
                    Limit: 100,
                  },
                  headers: {
                    Authorization: `Bearer ${client.token}`,
                  },
                }
              );
    
              if (receivingResponse.data.length > 0) {
                allReceiving = [...allReceiving, ...receivingResponse.data];
                receivingPage++;
              } else {
                hasMoreReceiving = false;
              }
            }
    
            // Fetch All Inventory Pages for the current client
            let inventoryPage = 1;
            let hasMoreInventory = true;
            while (hasMoreInventory) {
              const inventoryResponse = await axios.get(
                "https://api.shipbob.com/1.0/inventory",
                {
                  params: {
                    Page: inventoryPage,
                    Limit: 100,
                  },
                  headers: {
                    Authorization: `Bearer ${client.token}`,
                  },
                }
              );
    
              if (inventoryResponse.data.length > 0) {
                allInventory = [...allInventory, ...inventoryResponse.data];
                inventoryPage++;
              } else {
                hasMoreInventory = false;
              }
            }
          }
        } else {
          // Fetch data for the selected client
          const client = clients.find((c) => c.name === selectedClient);
          if (client) {
            // Fetch Receiving Data with pagination
            let receivingPage = 1;
            let hasMoreReceiving = true;
            while (hasMoreReceiving) {
              const receivingResponse = await axios.get(
                "https://api.shipbob.com/2.0/receiving",
                {
                  params: {
                    Page: receivingPage,
                    Limit: 100,
                  },
                  headers: {
                    Authorization: `Bearer ${client.token}`,
                  },
                }
              );
    
              if (receivingResponse.data.length > 0) {
                allReceiving = [...allReceiving, ...receivingResponse.data];
                receivingPage++;
              } else {
                hasMoreReceiving = false;
              }
            }
    
            // Fetch All Inventory Pages
            let inventoryPage = 1;
            let hasMoreInventory = true;
            while (hasMoreInventory) {
              const inventoryResponse = await axios.get(
                "https://api.shipbob.com/1.0/inventory",
                {
                  params: {
                    Page: inventoryPage,
                    Limit: 100,
                  },
                  headers: {
                    Authorization: `Bearer ${client.token}`,
                  },
                }
              );
    
              if (inventoryResponse.data.length > 0) {
                allInventory = [...allInventory, ...inventoryResponse.data];
                inventoryPage++;
              } else {
                hasMoreInventory = false;
              }
            }
          }
        }
    
        setReceiving(allReceiving);
        setFilteredReceiving(allReceiving);
        setInventoryItems(allInventory);
        setLoading(false);
      } catch (err) {
        setError("Error fetching data");
        console.error(err);
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedClient]); // Fetch data whenever selectedClient changes

  // Handle client change
  const handleClientChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedClient(selectedValue);

    // Only set the token if a specific client is selected
    if (selectedValue !== "All") {
      const client = clients.find((c) => c.name === selectedValue);
      if (client) {
        setToken(client.token);
      }
    }
  };

  const getItemNameById = (inventoryId) => {
    console.log("Inventory ID:", inventoryId);
    const item = inventoryItems.find((item) => item.id === inventoryId);
    console.log("Found Item:", item);
    return item ? item.name : "N/A";
  };

  // Handle filter by fulfillment center
  const handleFilterCenter = (e) => {
    setFilterCenter(e.target.value);
    filterReceiving(e.target.value, filterSearch, filterStatus);
  };

  // Handle search
  const handleSearch = (e) => {
    const searchTerm = e.target.value;
    setFilterSearch(searchTerm);
    filterReceiving(filterCenter, searchTerm, filterStatus);
  };

  // Handle status filter change
  const handleStatusChange = (e) => {
    setFilterStatus(e.target.value);
    filterReceiving(filterCenter, filterSearch, e.target.value);
  };

  // Filter receiving data
  const filterReceiving = (center, search, status) => {
    let updatedReceiving = receiving
      .map((item) => {
        // Check if the item itself matches the search term (e.g., item.id, item.status, etc.)
        const itemMatchesSearch =
          String(item.id).toLowerCase().includes(search.toLowerCase()) ||
          item.status.toLowerCase().includes(search.toLowerCase());
  
        // Filter the inventory_quantities array to only include rows that match the search term
        const filteredInventory = item.inventory_quantities.filter((inventory) => {
          const sku = inventory.sku || ""; // Fallback to an empty string if SKU is undefined
          const inventoryId = inventory.inventory_id ? String(inventory.inventory_id) : ""; // Fallback to an empty string if inventory_id is undefined
          const itemName = getItemNameById(inventory.inventory_id).toLowerCase(); // Get the item name and convert to lowercase
  
          return (
            sku.toLowerCase().includes(search.toLowerCase()) || // Match SKU
            inventoryId.toLowerCase().includes(search.toLowerCase()) || // Match Inventory ID
            itemName.includes(search.toLowerCase()) // Match Item Name
          );
        });
  
        // If the item itself matches the search term, include all its inventory quantities
        // Otherwise, only include the filtered inventory quantities
        return {
          ...item,
          inventory_quantities: itemMatchesSearch ? item.inventory_quantities : filteredInventory,
        };
      })
      .filter((item) => {
        // Check if fulfillment_center matches
        const fulfillmentCenterName = item.fulfillment_center?.name || "";
        const matchesCenter =
          center === "all" ||
          fulfillmentCenterName.toLowerCase().includes(center.toLowerCase());
  
        // Check if status matches
        const matchesStatus =
          status === "all" || item.status.toLowerCase() === status.toLowerCase();
  
        // Check if there are any inventory items left after filtering by SKU, Inventory ID, Item Name, etc.
        const hasMatchingInventory = item.inventory_quantities.length > 0;
  
        return matchesCenter && matchesStatus && hasMatchingInventory;
      });
  
    console.log("Filtered Receiving Data:", updatedReceiving); // Debugging
    setFilteredReceiving(updatedReceiving);
  };

  // Handle sorting
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredReceiving].sort((a, b) => {
      // Find the first inventory item for comparison
      const aValue = a.inventory_quantities[0][key];
      const bValue = b.inventory_quantities[0][key];

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredReceiving(sortedData);
  };

  const exportToExcel = () => {
    const dataToExport = [];

    filteredReceiving.forEach((item) => {
      if (item.inventory_quantities && item.inventory_quantities.length > 0) {
        item.inventory_quantities.forEach((inventory, index) => {
          const row = {
        "Serial No": dataToExport.length + 1,
  "Receiving ID": item.id,
  Status: item.status,
  "Fulfillment Center": item.fulfillment_center?.name || "N/A",
  ...(showFields.purchaseOrderNumber && {
    "PO Number": item.purchase_order_number || "N/A"
  }),
            "Fulfillment Center": item.fulfillment_center?.name || "N/A",
            "Inventory ID": inventory.inventory_id || "N/A",
            "Item Name": getItemNameById(inventory.inventory_id) || "N/A", // New Field
            SKU: inventory.sku || "N/A",
            "Expected Quantity": inventory.expected_quantity || "N/A",
            "Received Quantity": inventory.received_quantity || "N/A",
            "Stowed Quantity": inventory.stowed_quantity || "N/A",
          };

          // Only include "Insert Date" if the user has selected it
          if (showFields.insertDate) {
            row["Insert Date"] = new Date(item.insert_date).toLocaleString();
          }

          // Only include "Last Updated Date" if the user has selected it
          if (showFields.lastUpdatedDate) {
            row["Last Updated Date"] = new Date(
              item.last_updated_date
            ).toLocaleString();
          }

          dataToExport.push(row);
        });
      } else {
        const row = {
          "Serial No": dataToExport.length + 1,
          "Receiving ID": item.id,
          Status: item.status,
          "Fulfillment Center": item.fulfillment_center?.name || "N/A",
          "Inventory ID": "N/A",
          "Item Name": "N/A", // New Field
          SKU: "N/A",
          "Expected Quantity": "N/A",
          "Received Quantity": "N/A",
          "Stowed Quantity": "N/A",
        };

        // Only include "Insert Date" if the user has selected it
        if (showFields.insertDate) {
          row["Insert Date"] = new Date(item.insert_date).toLocaleString();
        }

        // Only include "Last Updated Date" if the user has selected it
        if (showFields.lastUpdatedDate) {
          row["Last Updated Date"] = new Date(
            item.last_updated_date
          ).toLocaleString();
        }

        dataToExport.push(row);
      }
    });

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "ReceivingList");
    XLSX.writeFile(wb, "ReceivingList.xlsx");
  };

  const handleFieldToggle = (field) => {
    setShowFields((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  if (loading) {
    return (
      <div className="loading-container" style={{ backgroundColor: "#f0f0f0" }}>
        <img
          src={Logo}
          alt="Loading"
          className="loading-icon"
          style={{ width: "250px", height: "150px" }}
        />
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
   <div
  style={{
    backgroundColor: "#E0F7FA",
    padding: "20px",
    borderRadius: "20px",
    minHeight: "100vh",
    height: "auto",
  }}
>
  <div className="container my-4">
    {/* Header Section */}
    <div className="d-flex justify-content-center position-relative mb-4">
      <h1 className="text-dark mb-0">Receiving</h1>
      <div className="position-absolute end-0">
        <DropdownButton
          variant="primary"
          title="Switch"
          size="sm"
          className="shadow-sm"
        >
          <Dropdown.Item onClick={() => navigate("/Inventory")}>
            Inventory
          </Dropdown.Item>
        </DropdownButton>
      </div>
    </div>

    {/* Filters */}
    <div className="mb-4 row align-items-end">
      {/* Client Selection */}
      <div className="col-md-2">
        <label className="form-label">Select Client:</label>
        <select
          value={selectedClient}
          onChange={handleClientChange}
          className="form-select"
        >
          {clients.map((client) => (
            <option key={client.name} value={client.name}>
              {client.name}
            </option>
          ))}
        </select>
      </div>

      {/* Fulfillment Center Filter */}
      <div className="col-md-2">
        <label className="form-label">Fulfillment Center:</label>
        <select
          value={filterCenter}
          onChange={handleFilterCenter}
          className="form-select"
        >
          <option value="all">All</option>
          <option value="Dallas">Dallas</option>
          <option value="Philadelphia">Philadelphia</option>
          <option value="Fresno">Fresno</option>
          <option value="Ramona">Ramona</option>
        </select>
      </div>

      {/* Status Filter */}
      <div className="col-md-2">
        <label className="form-label">Status:</label>
        <select
          value={filterStatus}
          onChange={handleStatusChange}
          className="form-select"
        >
          <option value="all">All</option>
          <option value="Awaiting">Awaiting</option>
          <option value="Processing">Processing</option>
          <option value="Completed">Completed</option>
        </select>
      </div>

      {/* Search Box */}
      <div className="col-md-2">
        <label className="form-label">Search:</label>
        <input
          type="text"
          value={filterSearch}
          onChange={handleSearch}
          className="form-control"
          placeholder="Enter search"
        />
      </div>

      {/* Field Selection Dropdown */}
      <div className="col-md-2">
        <label className="form-label">Select Fields:</label>
        <div className="dropdown">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            onClick={() => setShowFieldDropdown(!showFieldDropdown)}
          >
            Select Fields
          </button>
          <div
            className={`dropdown-menu ${showFieldDropdown ? "show" : ""}`}
            style={{ padding: "10px" }}
          >
          <div className="form-check">
  <input
    className="form-check-input"
    type="checkbox"
    checked={showFields.purchaseOrderNumber}
    onChange={() => handleFieldToggle("purchaseOrderNumber")}
    id="purchaseOrderNumber"
  />
  <label className="form-check-label" htmlFor="purchaseOrderNumber">
   PO No
  </label>
</div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={showFields.insertDate}
                onChange={() => handleFieldToggle("insertDate")}
                id="insertDate"
              />
              <label className="form-check-label" htmlFor="insertDate">
                Insert Date
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={showFields.lastUpdatedDate}
                onChange={() => handleFieldToggle("lastUpdatedDate")}
                id="lastUpdatedDate"
              />
              <label className="form-check-label" htmlFor="lastUpdatedDate">
                Last Updated Date
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Export Button - Right Aligned */}
      <div className="col-md-2 text-end">
        <button
          onClick={exportToExcel}
          className="btn btn-success shadow-sm"
        >
          Export to Excel
        </button>
      </div>
    </div>

    {/* Receiving Table */}
    <div className="table-responsive" style={{ overflowX: "auto" }}>
      <table 
        className="styled-table"
        style={{
          width: "100%",
          tableLayout: "fixed",
          borderCollapse: "collapse"
        }}
      >
        <thead style={{ backgroundColor: "red", color: "white" }}>
          <tr>
            <th style={{ width: "50px" }}>No</th>
            <th style={{ width: "120px" }}>Receiving ID</th>
            <th style={{ width: "100px" }}>Status</th>
            {showFields.insertDate && (
              <th style={{ width: "150px" }}>Insert Date</th>
            )}
            {showFields.lastUpdatedDate && (
              <th style={{ width: "150px" }}>Last Updated Date</th>
            )}
{showFields.purchaseOrderNumber && (
  <th style={{ width: "150px" }}>   PO No
</th>
)}
            <th style={{ width: "120px" }}>Inventory ID</th>
            <th style={{ width: "150px" }}>Item Name</th>
            <th style={{ width: "120px" }}>SKU</th>
            <th 
              style={{ width: "100px", cursor: "pointer" }}
              onClick={() => handleSort("expected_quantity")}
            >
              Expected Qty
              {sortConfig.key === "expected_quantity" &&
                (sortConfig.direction === "asc" ? " ↑" : " ↓")}
            </th>
            <th 
              style={{ width: "100px", cursor: "pointer" }}
              onClick={() => handleSort("received_quantity")}
            >
              Received Qty
              {sortConfig.key === "received_quantity" &&
                (sortConfig.direction === "asc" ? " ↑" : " ↓")}
            </th>
            <th 
              style={{ width: "100px", cursor: "pointer" }}
              onClick={() => handleSort("stowed_quantity")}
            >
              Stowed Qty
              {sortConfig.key === "stowed_quantity" &&
                (sortConfig.direction === "asc" ? " ↑" : " ↓")}
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredReceiving.map((item, itemIndex) =>
            item.inventory_quantities.map((inventory, index) => (
              <tr key={`${item.id}-${inventory.inventory_id}`}>
                {index === 0 && (
                  <>
                    <td 
                      rowSpan={item.inventory_quantities.length}
                      style={{
                        maxWidth: "50px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        padding: "8px"
                      }}
                    >
                      {itemIndex + 1}
                    </td>
                    <td 
                      rowSpan={item.inventory_quantities.length}
                      style={{
                        maxWidth: "120px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        padding: "8px"
                      }}
                      title={item.id}
                    >
                      {item.id}
                    </td>
                    <td 
                      rowSpan={item.inventory_quantities.length}
                      style={{
                        maxWidth: "100px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        padding: "8px"
                      }}
                    >
                      {item.status}
                    </td>
                    {showFields.insertDate && (
                      <td 
                        rowSpan={item.inventory_quantities.length}
                        style={{
                          maxWidth: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          padding: "8px"
                        }}
                      >
                        {new Date(item.insert_date).toLocaleString()}
                      </td>
                    )}
                    {showFields.lastUpdatedDate && (
                      <td 
                        rowSpan={item.inventory_quantities.length}
                        style={{
                          maxWidth: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          padding: "8px"
                        }}
                      >
                        {new Date(item.last_updated_date).toLocaleString()}
                      </td>
                    )}
                    {showFields.purchaseOrderNumber && (
  <td 
    rowSpan={item.inventory_quantities.length}
    style={{
      maxWidth: "150px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      padding: "8px"
    }}
    title={item.purchase_order_number || "N/A"}
  >
    {item.purchase_order_number || "N/A"}
  </td>
)}
                  </>
                )}
                <td style={{
                  maxWidth: "120px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  padding: "8px"
                }}>
                  {inventory.inventory_id}
                </td>
                <td style={{
                  maxWidth: "150px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  padding: "8px"
                }} title={getItemNameById(inventory.inventory_id)}>
                  {getItemNameById(inventory.inventory_id)}
                </td>
                <td style={{
                  maxWidth: "120px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  padding: "8px"
                }} title={inventory.sku}>
                  {inventory.sku}
                </td>
                <td style={{ padding: "8px" }}>{inventory.expected_quantity}</td>
                <td style={{ padding: "8px" }}>{inventory.received_quantity}</td>
                <td style={{ padding: "8px" }}>{inventory.stowed_quantity}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </div>
</div>
  );
};

export default ReceivingList;
